import dva from 'dva';
import { Component } from 'react';
import createLoading from 'dva-loading';
import history from '@tmp/history';

let app = null;

export function _onCreate() {
  const plugins = require('umi/_runtimePlugin');
  const runtimeDva = plugins.mergeConfig('dva');
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    ...(window.g_useSSR ? { initialState: window.g_initialData } : {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach(plugin => {
    app.use(plugin);
  });
  
  app.model({ namespace: 'accounts', ...(require('/Users/jason/Documents/Codes/f-oms/models/accounts.js').default) });
app.model({ namespace: 'csOrders', ...(require('/Users/jason/Documents/Codes/f-oms/models/csOrders.js').default) });
app.model({ namespace: 'eventLog', ...(require('/Users/jason/Documents/Codes/f-oms/models/eventLog.js').default) });
app.model({ namespace: 'exchangeOrder', ...(require('/Users/jason/Documents/Codes/f-oms/models/exchangeOrder.js').default) });
app.model({ namespace: 'fans', ...(require('/Users/jason/Documents/Codes/f-oms/models/fans.js').default) });
app.model({ namespace: 'goods', ...(require('/Users/jason/Documents/Codes/f-oms/models/goods.js').default) });
app.model({ namespace: 'index', ...(require('/Users/jason/Documents/Codes/f-oms/models/index.js').default) });
app.model({ namespace: 'liveFomCard', ...(require('/Users/jason/Documents/Codes/f-oms/models/liveFomCard.js').default) });
app.model({ namespace: 'menu', ...(require('/Users/jason/Documents/Codes/f-oms/models/menu.js').default) });
app.model({ namespace: 'notice', ...(require('/Users/jason/Documents/Codes/f-oms/models/notice.js').default) });
app.model({ namespace: 'order', ...(require('/Users/jason/Documents/Codes/f-oms/models/order.js').default) });
app.model({ namespace: 'orders', ...(require('/Users/jason/Documents/Codes/f-oms/models/orders.js').default) });
app.model({ namespace: 'products', ...(require('/Users/jason/Documents/Codes/f-oms/models/products.js').default) });
app.model({ namespace: 'session', ...(require('/Users/jason/Documents/Codes/f-oms/models/session.js').default) });
app.model({ namespace: 'shoppingCart', ...(require('/Users/jason/Documents/Codes/f-oms/models/shoppingCart.js').default) });
app.model({ namespace: 'wechatAccounts', ...(require('/Users/jason/Documents/Codes/f-oms/models/wechatAccounts.js').default) });
  return app;
}

export function getApp() {
  return app;
}

export class _DvaContainer extends Component {
  render() {
    const app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
